<template>
    <div>
        <!--内容部分 start-->
        <div>
            <!--蓝色背景 start-->
<!--            <div class="blue_bar">-->
<!--                &lt;!&ndash;标题 start&ndash;&gt;-->
<!--                <div class="blue_title">-->
<!--&lt;!&ndash;                    收入总额(元)&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;收入金额 start&ndash;&gt;-->
<!--                <div class="income">-->
<!--&lt;!&ndash;                    {{come.summary}}&ndash;&gt;-->
<!--                </div>-->
<!--                &lt;!&ndash;商户类别 start&ndash;&gt;-->
<!--                <div class="merchant_type" style="margin-top: 0.6rem;">-->
<!--                    <van-tag color="#00aaee" text-color="white" class="label">业务员</van-tag>-->
<!--                </div>-->
<!--                &lt;!&ndash;微信及支付宝收入 start&ndash;&gt;-->
<!--                <div class="income_type">-->

<!--                    <van-row gutter="10">-->
<!--                        <van-col span="8">-->
<!--                            <div >-->
<!--&lt;!&ndash;                                微信(今)&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="kind">{{come.alipay_summary}}</div>&ndash;&gt;-->
<!--                            </div>-->

<!--                        </van-col>-->
<!--                        <van-col span="8">-->
<!--                            <div >-->
<!--&lt;!&ndash;                                支付宝(今)&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="kind">{{come.wxpay_summary}}</div>&ndash;&gt;-->
<!--                            </div>-->

<!--                        </van-col>-->
<!--                        <van-col span="8">-->
<!--                            <div >-->
<!--&lt;!&ndash;                                云闪付(今)&ndash;&gt;-->
<!--&lt;!&ndash;                                <div class="kind">{{come.unionpay_summary}}</div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
<!--                </div>-->
<!--            </div>-->
            <!--蓝色背景 end-->
            <!--菜单 start-->
            <div style="margin-top: 0.3rem">
                <van-grid :column-num="3" icon-size="1rem">
                    <van-grid-item :to="menu_item.menu_url" v-for="(menu_item,key) in menu_data" :key="key"
                                   :icon="menu_item.menu_img" :text="menu_item.menu_text"/>
                </van-grid>
            </div>
            <!--菜单 end-->
        </div>
        <!--内容部分 end-->
    </div>
</template>

<script>
    // 菜单图片
    import merchant_information from '../../assets/images/merchant_information.png'; //已进商户
    import transaction_flow from '../../assets/images/transaction_flow.png'; //交易流水
    import Summary from '../../assets/images/express_collection.png'; //交易汇总
    import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
    // import collection_code from '../../assets/images/collection_code.png'; //收款码
    // import express_collection from '../../assets/images/express_collection.png'; //快速收款
    // import express_collection_2 from '../../assets/images/express_collection_2.png'; //快捷收款

    export default {
        name: "SalesmanHomepage", //商户首页
        data() {
            return {
                // 收入金额
                come:"",
                menu_data: [
                    {
                        'menu_text': "业务员信息",
                        'menu_img': transaction_flow,
                        'menu_url': "/SalesmanInformation"
                    },
                    {
                        'menu_text': "已进商户",
                        'menu_img': merchant_information,
                        'menu_url': "/Merchantlist"
                    },
                    {
                        'menu_text': "交易汇总",
                        'menu_img': Summary,
                        'menu_url': "/AgentSummary"
                    },
                     {
                        'menu_text': "开通卡券",
                        'menu_img': Summary,
                        'menu_url': "/merchants_add"
                    },
                    {
                        'menu_text': "企业入驻",
                        'menu_img': Summary,
                        'menu_url': "/enterprise_add"
                    },
                    {
                        'menu_text': "企业查询",
                        'menu_img': Summary,
                        'menu_url': "/enterprise_list"
                    },
                    {
                        'menu_text': "新增商户",
                        'menu_img': Summary,
                        'menu_url': "/Merchant/add"
                    },
					{
					    'menu_text': "开通扫码点餐",
					    'menu_img': Summary,
					    'menu_url': "/OpenOrderCode"
					},

                ],
                //    {
                //         'menu_text': "快捷收款",
                //         'menu_img': express_collection_2,
                //         'menu_url': "/QuickPayment"
                //     },
                // {
                //     'menu_text': "",
                //     'menu_img': "",
                //     'menu_url': ""
                // },
                //  {
                //         'menu_text': "我的收款码",
                //         'menu_img': collection_code,
                //         'menu_url': ""
                //     },
                //     {
                //         'menu_text': "快速收款",
                //         'menu_img': express_collection,
                //         'menu_url': ""
                //     },

            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        methods: {
            //收入金额
            income(){
                // this.$http.get('/wechat/user/homepage', {
                //     params: {
                //         merchant_id: window.sessionStorage.getItem("commercialId"),
                //     }
                // }).then(response => {
                //     // console.log(response.data);
                //     this.come=response.data.data
                // })
            }
        },
        mounted(){
            // 收入金额
            this.income()
        },
    }
</script>

<style scoped>
    /*蓝色背景*/
    .blue_bar {
        background-color: #00aaee;
        width: 100%;
        color: white;
        text-align: center;
        padding: 0.3rem 0;
    }

    /*标题*/
    .blue_title {
        color: #DEF0FD;
        line-height: 40px;
        font-size: 14px;
    }

    /*收入金额*/
    .income {
        line-height: 40px;
        font-size: 45px;
    }

    /*商户类别整体*/
    .merchant_type {
        padding: 14px 0;
    }

    /*商户类别*/
    .label {
        border: 1px solid #fff;
        border-radius: 5px;
        padding: 3px 10px;
        font-size: 16px;
    }

    /*收入类别*/
    .income_type {
        padding: 14px 0;
        font-size: 16px;
    }
    .kind{
        position: relative;
        top: 0.1rem;
        font-size: 0.5rem;
    }
</style>
